import { ColumnDef, Table } from '@shape-ds/components';
import { CaseListItem } from 'queries/cases/types';
import { Key, useMemo, useState } from 'react';

interface Props {
  handleClick: (caseItem?: CaseListItem) => void;
  data: CaseListItem[];
  columns: Array<ColumnDef<CaseListItem>>;
}

export const CaseListTable = ({ columns, data, handleClick }: Props) => {
  const [rowId, setRowId] = useState<string>();
  const find = useMemo(() => (rowId: Key) => data.find((row) => row.id === rowId), [data]);

  return (
    <Table<CaseListItem>
      data={data}
      columns={columns}
      style={{ maxHeight: 120 }}
      className="case-list-table"
      onRowClick={(rowId: Key, isExpanded: boolean, isSelected: boolean) => {
        if (isSelected) {
          setRowId(undefined);
          handleClick(undefined);
        } else {
          setRowId(rowId as string);
          handleClick(find(rowId));
        }
      }}
      selectedRows={rowId ? [rowId] : []}
    />
  );
};
